<div  class="relative flex-1 flex flex-col px-base overflow-y-auto">
    <div class="sticky top-0 bg-white w-full h-12 px-1 pt-base flex justify-between items-start text-viewer-secondary text-lg">
        <div class="flex items-center justify-center gap-x-2">
            <meta-icon icon="settings"></meta-icon>
            <p class="inline-block">{{'Settings' | translate}}</p>
        </div>
        <button class="inline-flex items-center justify-center gap-x-2" (click)="onClose()">
            <p>{{'Close' | translate}}</p>
            <meta-icon icon="close" additionalClasses="text-base"></meta-icon>
        </button>
    </div>

    <div class="px-1 flex flex-col overflow-y-auto mt-4 pt-2 border-t border-t-gray-300 scrollbar-custom">
        <div class="mb-6 px-1 border-b border-b-gray-300 flex flex-col">
            <h3 class="font-semibold text-[1.4rem] pb-6">{{'Toolbar position' | translate}}</h3>
            <div class="flex space-x-2 justify-around pb-4">
                <div class="relative">
                    <input id="left" class="peer sr-only" type="radio" name="left" 
                        [checked]="$currentPosition() === 'left' ? 'checked' : null"
                        (change)="onChangePosition('left')" />
                    <label for="left"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentPosition() === 'left' }" >
                        {{'Left' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="right" class="peer sr-only" type="radio" name="right"
                        [checked]="$currentPosition() === 'right' ? 'checked' : null"
                        (change)="onChangePosition('right')" />
                    <label for="right"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentPosition() === 'right' }" >
                        {{'Right' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="top" class="peer sr-only" type="radio" name="top"
                        [checked]="$currentPosition() === 'top' ? 'checked' : null"
                        (change)="onChangePosition('top')" />
                    <label for="top"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentPosition() === 'top' }" >
                        {{'Top' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="bottom" class="peer sr-only" type="radio" name="bottom"
                        [checked]="$currentPosition() === 'bottom' ? 'checked' : null"
                        (change)="onChangePosition('bottom')" />
                    <label for="bottom"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentPosition() === 'bottom' }">
                        {{'Bottom' | translate}}
                    </label>
                </div>
            </div>
        </div>

        <div class="mb-6 px-1 border-b border-b-gray-300 flex flex-col">
            <h3 class="font-semibold text-[1.4rem] pb-6">{{'Toolbar floating' | translate}}</h3>
            <div class="flex space-x-2 justify-around pb-4">
                <div class="relative">
                    <input id="floating-enabled" class="peer sr-only" type="radio" name="floating-enabled" 
                        [checked]="$currentFloating() ? 'checked' : null"
                        (change)="onChangeFloating(true)" />
                    <label for="floating-enabled"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentFloating() }" >
                        {{'Yes' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="floating-disabled" class="peer sr-only" type="radio" name="floating-disabled"
                        [checked]="!$currentFloating() ? 'checked' : null"
                        (change)="onChangeFloating(false)" />
                    <label for="floating-disabled"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': !$currentFloating() }" >
                        {{'No' | translate}}
                    </label>
                </div>
            </div>
        </div>

        <div class="mb-6 px-1 border-b border-b-gray-300 flex flex-col">
            <h3 class="font-semibold text-[1.4rem] pb-6">{{'Page orientation' | translate}}</h3>
            <div class="flex space-x-2 justify-around pb-4">
                <div class="relative">
                    <input id="vertical" class="peer sr-only" type="radio" name="vertical" 
                        [checked]="$currentOrientation() === 'vertical' ? 'checked' : null"
                        (change)="onChangeOrientation('vertical')" />
                    <label for="vertical"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentOrientation() === 'vertical' }" >
                        {{'Vertical' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="horizontal" class="peer sr-only" type="radio" name="horizontal"
                        [checked]="$currentOrientation() === 'horizontal' ? 'checked' : null"
                        (change)="onChangeOrientation('horizontal')" />
                    <label for="horizontal"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentOrientation() === 'horizontal' }" >
                        {{'Horizontal' | translate}}
                    </label>
                </div>
            </div>
        </div>

        <div class="mb-6 px-1 border-b border-b-gray-300 flex flex-col">
            <h3 class="font-semibold text-[1.4rem] pb-6">{{'Page margins' | translate}}</h3>
            <div class="flex space-x-2 justify-around pb-4">
                <div class="relative">
                    <input id="small" class="peer sr-only" type="radio" name="small" 
                        [checked]="$currentMargins() === 'small' ? 'checked' : null"
                        (change)="onChangeMargins('small')" />
                    <label for="small"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentMargins() === 'small' }" >
                        {{'Small' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="normal" class="peer sr-only" type="radio" name="normal" 
                        [checked]="$currentMargins() === 'normal' ? 'checked' : null"
                        (change)="onChangeMargins('normal')" />
                    <label for="normal"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentMargins() === 'normal' }" >
                        {{'Normal' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="large" class="peer sr-only" type="radio" name="large" 
                        [checked]="$currentMargins() === 'large' ? 'checked' : null"
                        (change)="onChangeMargins('large')" />
                    <label for="large"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentMargins() === 'large' }" >
                        {{'Large' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="extra-large" class="peer sr-only" type="radio" name="extra-large" 
                        [checked]="$currentMargins() === 'extra-large' ? 'checked' : null"
                        (change)="onChangeMargins('extra-large')" />
                    <label for="extra-large"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentMargins() === 'extra-large' }" >
                        {{'Extra Large' | translate}}
                    </label>
                </div>
            </div>
        </div>

        <div class="mb-6 px-1 border-b border-b-gray-300 flex flex-col">
            <h3 class="font-semibold text-[1.4rem] pb-6">{{'Progress bar' | translate}}</h3>
            <div class="flex space-x-2 justify-around pb-4">
                <div class="relative">
                    <input id="progress-bar-enabled" class="peer sr-only" type="radio" name="progress-bar-enabled" 
                        [checked]="$currentProgressBar() ? 'checked' : null"
                        (change)="onChangeProgressBar(true)" />
                    <label for="progress-bar-enabled"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': $currentProgressBar() }" >
                        {{'Yes' | translate}}
                    </label>
                </div>
                <div class="relative">
                    <input id="progress-bar-disabled" class="peer sr-only" type="radio" name="progress-bar-disabled"
                        [checked]="!$currentProgressBar() ? 'checked' : null"
                        (change)="onChangeProgressBar(false)" />
                    <label for="progress-bar-disabled"
                        class="cursor-pointer peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-1 peer-focus:outline-black"
                        [ngClass]="{ 'text-secondary': !$currentProgressBar() }" >
                        {{'No' | translate}}
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>